import React, { useEffect, useState } from 'react'
import {
    Breadcrumb,
    Button,
    Card,
    Col,
    Container,
    Form,
    InputGroup,
    Modal,
    Row,
    Table,
} from 'react-bootstrap'
import './style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { Formik } from 'formik';
import Write from 'asset/SvgComponent/Write'
import Delete from 'asset/SvgComponent/Delete'
import EditIcon from 'asset/SvgComponent/EditIcon'
import Pagination from 'components/Pagination'
import Loader from 'components/Loader'
import Alert from 'components/Alert'
import Dialog from 'components/Dialog'
import axios from 'api/index'
import { IAPI_Response } from 'api/types'
import {
    API_ENDPOINT,
    SUCCESS_MESSAGE,
    ERROR_MESSAGE,
    TEXT
} from 'utils/globalConstant'
import {IAlarmConfigurations, ICondition, IList} from "./types";
import moment from "moment/moment";
import Select from "components/ReactSelect";
import {IEmployee} from "../../../Attendance/AttendanceReport/Retail/types";
import CheckIcon from "asset/SvgComponent/CheckIcon";
import { Link } from 'react-router-dom'

export default function Index() {
    const [searched, setSearched] = React.useState("")
    const [entries, setEntries] = React.useState(10)

    const [currentPage, setCurrentPage] = React.useState(0)
    const [lastPage, setLastPage] = React.useState(0)
    const [itemsPerPage, setPerPage] = React.useState(10)
    const [itemsCount, setItemCount] = React.useState(0)
    const [from, setFrom] = React.useState(0)

    const [error, setError] = React.useState('')
    const [success, setSuccess] = React.useState('')
    const [showError, setShowError] = React.useState(false)
    const [showSuccess, setShowSuccess] = React.useState(false)
    const [showLoading, setShowLoading] = React.useState(false)

    const [showCreate, setShowCreate] = React.useState(false)
    const handleCloseCreate = () => {
        setShowCreate(false)
    }
    const handleShowCreate = () => {
        setShowCreate(true)
    }

    const [showEdit, setShowEdit] = React.useState(false)
    const handleCloseEdit = () => {
        setShowEdit(false)
        setSelectedEmployeeOption(
            {value: 0, label: "All Employees"}
        )
    }
    const handleShowEdit = () => setShowEdit(true)

    const [data, setData] = React.useState<IList[]>([])
    const [employeeOptions, setEmployeeOptions] = useState<{value: number, label: string}[]>([]);
    const [selectedEmployeeOption, setSelectedEmployeeOption] = useState<{value: number, label: string}>({value: 0, label: "All Employees"})
    const [machine, setMachine] = useState({
        id: 0,
        pc_name: "",
        machine_uiid: ""
    })

    const handleChangeSearch = async (e: any) => {
        setSearched(e.target.value)
        await getAlarmConfigurations(null, e.target.value, entries)
    }

    const displayCondition = (conditions: ICondition[], condition_type: any) => {
        let condition = "";
        let conditionType = "AND";
        if(condition_type == 0){
            conditionType = "OR";
        }

        conditions.map((con, index) => {
            condition += ` (${con.field} ${con.operator} ${con.value}) `
            if(index != conditions.length - 1){
                condition += conditionType
            }
            // console.log(condition.field)
        })

        return condition
    }

    const getAlarmConfigurations = async (page_number: null | number, searched: string, entries: number) => {
        setShowLoading(true)
        try {
            const response = await axios.get<IAPI_Response<IAlarmConfigurations>>(API_ENDPOINT.GET_ALARM_CONFIGURATIONS, {
                params: {
                    page: page_number,
                    searched: searched,
                    entries: entries
                },
            })
            const result = await response
            console.log(result?.data?.results?.data)
            if (result?.data?.results?.data?.length) {
                setData(result?.data?.results?.data)
                setCurrentPage(result?.data?.results?.current_page)
                setLastPage(result?.data?.results?.last_page)
                setPerPage(result?.data?.results?.per_page)
                setItemCount(result?.data?.results?.total)
                setFrom(result?.data?.results?.from)
            }
            setShowLoading(false)
        } catch {
            setShowError(true)
            setError(ERROR_MESSAGE.SYSTEM_ERROR)
        }

        setTimeout(() => {
            setShowError(false)
        }, 3000);
    }

    const showMachine = async (id: number) => {
        console.log("id ", id)
        handleShowEdit()
    }

    const handleChangeStatus = async (e: any, id: number) => {

        await axios.put(API_ENDPOINT.PUT_ALARM_CONFIGURATION_STATUS, {
            id: id,
            status: e.target.checked
        }).then(response => {
            if (response?.data?.status * 1 === 1) {
                setShowSuccess(true)
                setSuccess(SUCCESS_MESSAGE.ALARM_CONFIGURATION.UPDATED)
            }
            handleCloseEdit();
        }).catch(error => {
            setShowError(true)
        })

        setTimeout(() => {
            setShowError(false)
            setShowSuccess(false)
        }, 3000);
    }

    // const getAllEmployee = async () => {
    //     try {
    //         const res = await axios.get<IAPI_Response<IEmployee[]>>(API_ENDPOINT.ALL_EMPLOYEE)
    //         const result = await res
    //         if (result?.data?.results?.length) {
    //             const employees = result?.data?.results;
    //             setEmployeeOptions([])
    //             setEmployeeOptions(current => [...current, {value: 0, label: "All Employees"}]);
    //             employees.map(employee => {
    //                 setEmployeeOptions(current => [...current, {value: employee.employee_id, label: employee.first_name + " " + employee.last_name}]);
    //             })
    //
    //         }
    //     } catch {
    //         console.log('There is something wrong')
    //     }
    // }



    useEffect(() => {
        ;(async () => {
            await getAlarmConfigurations(null, searched, entries)
            // getAllEmployee()
        })()
    }, [])

    return (
        <>
            <Container fluid>
                <h5 className='fw-bold'>Alarm Configuration</h5>
                <Breadcrumb className='breadcrumbs'>
                    <Breadcrumb.Item className=' text-decoration-none' href='#'>
                        Home
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className=' text-decoration-none' href='#'>
                        Monitoring
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className=' text-decoration-none' href='#'>
                        Alarms
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Alarm Configuration</Breadcrumb.Item>
                </Breadcrumb>

                <Alert
                    type="success"
                    show={showSuccess}
                    message={success}
                    setShow={() => {
                        setShowSuccess(false);
                    }
                    }
                />

                <Alert
                    type="error"
                    show={showError}
                    message={error}
                    setShow={() => {
                        setShowError(false);
                    }
                    }
                />
                <Card className='border-0  p-0 bordered-card'>
                    <Card.Body>
                        <Row>
                            <Col sm={6}>
                                <span className='fw-bold'>&nbsp;</span>
                            </Col>
                            <Col sm={6} className='d-flex justify-content-end hidden'>
                                <InputGroup size='sm' className={'w-25'}>
                                    <Form.Control
                                        aria-label='search'
                                        aria-describedby='inputGroup-sizing-sm'
                                        placeholder='Search...'
                                        onChange={handleChangeSearch}
                                    />
                                    <InputGroup.Text className='bg-transparent search-input '>
                                        <FontAwesomeIcon icon={faSearch} />
                                    </InputGroup.Text>
                                </InputGroup>
                                {/*<Button*/}
                                {/*    onClick={handleShowCreate}*/}
                                {/*    className=' add-new-btn rounded mx-2 text-white'*/}
                                {/*    variant='warning'*/}
                                {/*>*/}
                                {/*    <EditIcon/>*/}
                                {/*    &nbsp;Add New Alarm*/}
                                {/*</Button>*/}
                            </Col>
                        </Row>

                        <Table responsive className='bordered-tabs-top mt-3'>
                            <thead>
                            <tr>
                                <th style={{ width: '3%' }} className='text-center'>
                                    No.
                                </th>
                                <th style={{ width: '10%' }} className='text-center'>
                                    Type
                                </th>
                                <th style={{ width: '20%' }} className='text-center'>
                                    Name
                                </th>
                                <th style={{ width: '35%' }} className='text-center'>
                                    Conditions
                                </th>
                                <th className='text-center'>
                                    Screenshot
                                </th>
                                <th className='text-center'>
                                    Email
                                </th>
                                {/*<th className='text-center'>*/}
                                {/*    Message*/}
                                {/*</th>*/}
                                <th className='text-center'>
                                    Status
                                </th>
                                <th style={{ width: '10%' }} className='text-center'>
                                    Action
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <>
                                {data.length > 0 ? (
                                    data.map((item, index) =>
                                        <tr className='mb-2' key={index}>
                                            <td className={'text-center'}>{from + index}</td>
                                            <td className={'text-center'}>{item.condition_type == "activity" ? "Activity" : "Security"}</td>
                                            <td>{item.name}</td>
                                            <td className={'display-condition'} title={displayCondition(item.conditions, item.condition_type)}>{displayCondition(item.conditions, item.condition_type)}</td>
                                            <td className={'text-center'}>{item.capture_screenshot == 1 ? <CheckIcon/> : "-"}</td>
                                            <td className={'text-center'}>{item.send_email == 1 ? <CheckIcon/> : "-"}</td>
                                            {/*<td className={'text-center'}>{item.display_message  == 1 ? <CheckIcon/> : "-"}</td>*/}
                                            <td>
                                                <Form.Check
                                                    type="switch"
                                                    id="custom-switch"
                                                    label=""
                                                    checked={item.is_active == 1? true:false}
                                                    onChange={(e) => {
                                                        const updatedData = [...data]; // Make a shallow copy of the array
                                                        updatedData[index] = {
                                                            ...item, // Copy the item object
                                                            is_active: e.target.checked ? 1 : 0 // Update the enable field
                                                        };
                                                        setData(updatedData); // Update state with the new array
                                                        handleChangeStatus(e, item.id)
                                                    }}
                                                />
                                            </td>
                                            <td className={'text-center'}>
                                                <Link to={`/monitoring/alarms/configuration/${item.id}`}>
                                                    <Button
                                                        className=' p-1 pt-0 pb-0'
                                                        style={{ fontSize: '12px', color: 'white' }}
                                                        variant=' btn-transparent'
                                                        size='sm'
                                                    >
                                                        <Write/>
                                                    </Button>
                                                </Link>
                                                {/*<Button*/}
                                                {/*    className=' p-1 pt-0 pb-0'*/}
                                                {/*    style={{ fontSize: '12px', color: 'white' }}*/}
                                                {/*    variant=' btn-transparent'*/}
                                                {/*    size='sm'*/}
                                                {/*>*/}
                                                {/*    <Delete/>*/}
                                                {/*</Button>*/}
                                            </td>
                                        </tr>
                                    )
                                ) : (
                                    <tr className='no-item'>
                                        <td colSpan={8}>{TEXT.NOT_FOUND}</td>
                                    </tr>
                                )}
                            </>
                            </tbody>
                        </Table>

                        <Pagination
                            itemsCount={itemsCount}
                            itemsPerPage={itemsPerPage}
                            currentPage={currentPage}
                            lastPage={lastPage}
                            setCurrentPage={setCurrentPage}
                            alwaysShown={false}
                            pageClicked={(page: number) => {
                                getAlarmConfigurations(page, searched, entries);
                            }
                            }
                        />
                    </Card.Body>
                </Card>
                {/*<Dialog*/}
                {/*    show={showConfirm}*/}
                {/*    setShow={handleCloseConfirm}*/}
                {/*    setEvent={() => {*/}
                {/*        deleteAllowance(item.allowance_id)*/}
                {/*    }*/}
                {/*    }*/}
                {/*/>*/}

                <Loader show={showLoading}/>

                {/* CREATE MODAL*/}

                <Modal className='modal' centered show={showCreate} onHide={handleCloseCreate}>
                    <Modal.Header closeButton>
                        <Modal.Title className='fw-bold'>Recognize Machine</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Col sm={5}>
                                    <Form.Group className='mb-1' controlId='exampleForm.ControlInput1'>
                                        <Form.Label className='fw-bold'>PC Name: </Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col sm={7}>
                                    <Form.Group className='mb-1' controlId='exampleForm.ControlInput1'>
                                        <Form.Label >{machine.pc_name}</Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={5}>
                                    <Form.Group className='mb-1' controlId='exampleForm.ControlInput1'>
                                        <Form.Label className='fw-bold'>Machine UUID: </Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col sm={7}>
                                    <Form.Group className='mb-1' controlId='exampleForm.ControlInput1'>
                                        <Form.Label>{machine.machine_uiid}</Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={5}>
                                    <Form.Group className='mb-1' controlId='exampleForm.ControlInput1'>
                                        <Form.Label className='fw-bold'>Owned By: </Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col sm={7}>
                                    <Form.Group className='mb-1' controlId='exampleForm.ControlInput1'>
                                        <Select
                                            name="employee_id"
                                            value={selectedEmployeeOption}
                                            options={employeeOptions}
                                            onChange={(e: any) => {
                                                setSelectedEmployeeOption(e)
                                                // handleSubmit();
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='outline-primary' size={'sm'} onClick={handleCloseCreate}>
                            Cancel
                        </Button>
                        <Button
                            // onClick={assignMachine}
                            type="submit"
                            disabled={selectedEmployeeOption.value == 0 ? true: false}
                            form="allowanceEdit"
                            variant='primary text-white'
                            size={'sm'}
                            className='mx-2'
                        >
                            Assign
                        </Button>
                    </Modal.Footer>
                </Modal>
                <br />
            </Container>
        </>
    )
}
